import React, {Component} from "react";
import App from "../App";
import UserHeader from "./components/UserHeader";
import UserService from "../services/user-service";
import Loading from "../common/Loading/Loading";
import "./UserProfile.css";
import toastr from "toastr";
import ToastOptions from "../common/toast/toastr-config.js";
import ConfirmDialog from "../common/ConfirmDialog/ConfirmDialog.js";
import CreateDialog from "../common/CreateDialog/CreateDialog";
import HistoryBackLink from "../common/BackLink/HistoryBackLink";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import UserApps from "./components/UserApps";
import ActivationButton from "../common/ActivationButton/ActivationButton";
import {Button} from "reactstrap";
import History from "./components/History";

class UserProfile extends Component {
    mount = false;

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            user: {
                email: "",
                emailVerified: false,
                createdAt: "",
                updatedAt: "",
                lastLogin: "",
                loginsCount: 0,
                isActive: true,
                name: "",
                lastIp: "",
                lastPasswordReset: "",
                isDtnEmployee: false,
                appMetaData: {permissions: {}},
                firstName: "",
                lastName: ""
            },
            isEditUserModalVisible: false,
            isDeactivateUserModalVisible: false,
            isResendVerificationModalVisible: false,
            invalidFields: {
                firstName: {
                    invalid: false,
                    message: ""
                },
                lastName: {
                    invalid: false,
                    message: ""
                },
                reNewPassword: {
                    invalid: false,
                    message: ""
                }
            },
            newPassword: "",
            reNewPassword: "",
            isDialogLoading: false
        };
    }

    componentDidMount() {
        this.mount = true;
        this.fetchUser();
    }



    fetchUser = async () => {
        if (this.mount) {
            this.setState({loading: true});
        }
        const userId = this.props.match.params.id;
        try {
            const user = await UserService.getUserById(userId);
            if (this.mount) {
                this.initializeStates(user.data);
            }
        } catch (error) {
            toastr.options = ToastOptions;
            toastr.error(error.message);
        }
        this.mount = false
    };

    initializeStates = data => {
        this.setState({
            user: data,
            loading: false
        });
    };

    changeUserStatus = async (user) => {
        try {
            this.setState({isDialogLoading: true});

            let newStatus = {
                status: !user.isActive
            }
            const response = await UserService.updateUser(this.state.user.userId, newStatus);
            this.setState({
                isDeactivateUserModalVisible: false,
                user: response.data,
                isDialogLoading: false
            });
            toastr.options = ToastOptions;
            toastr.success(
                response.data.isActive
                    ? "The user has been activated."
                    : "The user has been deactivated."
            );
        } catch (error) {
            this.setState({isDialogLoading: false});
            toastr.options = ToastOptions;
            toastr.error(error.message);
        }
    };

    handleResendVerification = () => {
        this.handleSendVerificationEmail(this.props.match.params.id);
        this.setState({isResendVerificationModalVisible: false});
    };

    handleSendVerificationEmail = async userId => {
        try {
            this.setState({isDialogLoading: true});
            await UserService.resendVerificationEmail(userId);
            this.setState({isDialogLoading: false});
            toastr.options = ToastOptions;
            toastr.success("Verification email sent.");
        } catch (error) {
            this.setState({isDialogLoading: false});
            toastr.options = ToastOptions;
            toastr.error("Unable to send verification email.");
            toastr.error(error.message);
        }
    };

    resetPassword = async () => {
        try {
            this.validateReNewPassword({
                target: {value: this.state.reNewPassword}
            });
            if (this.state.newPassword === this.state.reNewPassword) {
                const newState = {
                    password: this.state.newPassword,
                    re_password: this.state.reNewPassword
                };

                this.setState({isDialogLoading: true});
                await UserService.updateUser(this.state.user.userId, newState);
                this.setState({
                    isResetPasswordModalVisible: false,
                    isDialogLoading: false
                });
                this.resetState();
                toastr.options = ToastOptions;
                toastr.success("The password has been reset.");
            }
        } catch (error) {
            this.setState({
                isDialogLoading: false,
                isResetPasswordModalVisible: true
            });
            if (error.response.data.error) {
                toastr.options = ToastOptions;
                toastr.error(error.response.data.error.message);
            } else {
                toastr.options = ToastOptions;
                toastr.error(error.response.data.message);
            }
        }
    };

    handleEditDialogToggle = () => {
        if (!this.state.isEditUserModalVisible) {
            this.setState({
                isEditUserModalVisible: !this.state.isEditUserModalVisible,
                firstName: this.state.user.firstName,
                lastName: this.state.user.lastName,
                invalidFields: {
                    ...this.state.invalidFields,
                    firstName: {
                        invalid: false,
                        message: ""
                    },
                    lastName: {
                        invalid: false,
                        message: ""
                    }
                }
            });
        } else {
            this.setState({
                isEditUserModalVisible: !this.state.isEditUserModalVisible,
                invalidFields: {
                    ...this.state.invalidFields,
                    firstName: {
                        invalid: false,
                        message: ""
                    },
                    lastName: {
                        invalid: false,
                        message: ""
                    }
                }
            });
        }
    };

    setIsEmployee = (e) => {
        this.setState({
            user: {...this.state.user, isDtnEmployee: e.target.checked}
        });
    };

    validName = (e, name_field) => {
        const newName = e.target.value.trim();
        let isNameInvalid = this.state.invalidFields[name_field].invalid;
        if (newName === "") {
            isNameInvalid = true;
        } else {
            isNameInvalid = false;
        }
        let localUser = {...this.state.user}
        localUser[name_field] = newName;

        this.setState({
            invalidFields: {
                ...this.state.invalidFields,
                [name_field]: {
                    invalid: isNameInvalid,
                    message: isNameInvalid ? "Required field" : ""
                }
            },
            user: localUser
        });
    };

    handleErrors = error => {
        let errorData = error.response.data;
        let statusCode = errorData.error.statusCode;
        let name = errorData.error.name;

        if (name === "Validation Error") {
            let newState = this.state.invalidFields;

            if (statusCode === 400) {
                let body = errorData.error.body;
                body.forEach(fieldError => {
                    let field = fieldError.field;
                    let message = fieldError.message;

                    if (field === "firstName") {
                        newState.firstName.invalid = true;
                        newState.firstName.message = message;
                    }

                    if (field === "lastName") {
                        newState.lastName.invalid = true;
                        newState.lastName.message = message;
                    }
                });
            }

            this.setState({invalidFields: newState});
            toastr.options = ToastOptions;
            toastr.error(`${errorData.error.message}.`);
        } else {
            toastr.options = ToastOptions;
            toastr.error(error.message);
        }
    };

    updateUser = async (body) => {
        try {
            const response = await UserService.updateUser(this.state.user.userId, body);
            this.setState({
                user: response.data,
                isDialogLoading: false
            });
            toastr.options = ToastOptions;
            toastr.success("The user has been updated.");
        } catch (error) {
            this.setState({isDialogLoading: false});
            this.handleErrors(error);
        }
    }

    editUser = async () => {
        this.setState({isDialogLoading: true});
        try {
            let user = {}  //We will use this to patch user_metadata
            user.firstName = this.state.user.firstName
            user.lastName = this.state.user.lastName
            user.isDtnEmployee = this.state.user.isDtnEmployee
            this.updateUser(user)

            this.handleEditDialogToggle();
        } catch (error) {
            this.setState({isDialogLoading: false});
            this.handleErrors(error);
        }
    };

    validateNewPassword = e => {
        let newPassword = e.target.value.trim();

        this.setState({
            newPassword
        });
    };

    validateReNewPassword = e => {
        let reNewPassword = e.target.value.trim();
        let isNewRePasswordValid = this.state.invalidFields.reNewPassword.invalid;
        let message = this.state.invalidFields.reNewPassword.message;

        if (reNewPassword !== this.state.newPassword) {
            isNewRePasswordValid = true;
            message = "Password should be equal.";
        } else {
            isNewRePasswordValid = false;
            message = "";
        }

        this.setState({
            invalidFields: {
                ...this.state.invalidFields,
                reNewPassword: {
                    invalid: isNewRePasswordValid,
                    message: message
                }
            },
            reNewPassword
        });
    };

    handleResetPasswordDialogToggle = () => {
        this.setState({
            isResetPasswordModalVisible: !this.state.isResetPasswordModalVisible
        });
    };

    resetState = () => {
        this.setState({
            invalidFields: {
                ...this.state.invalidFields,
                reNewPassword: {
                    invalid: false,
                    message: ""
                }
            },
            newPassword: "",
            reNewPassword: ""
        });
    };

    render() {
        return (
            <App {...this.props}>
                {this.state.loading && <Loading className="user-loading"/>}
                <HistoryBackLink directionName="Users"/>

                <div className="user-profile">
                    <div className="user-title">
                        <span className="name">{this.state.user.firstName} {this.state.user.lastName}</span>
                        <div className="actions">
                            <Button
                                onClick={() => this.handleEditDialogToggle()}
                                outline
                                color={this.props.isActive ? "warning" : "success"}
                                className={`btn`}
                                size="sm">Edit</Button>
                            <Button
                                onClick={() => this.setState({isResendVerificationModalVisible: true})}
                                outline
                                color={this.props.isActive ? "warning" : "success"}
                                className={`btn`}
                                size="sm">Resend Verification</Button>
                            <Button
                                onClick={() =>
                                    this.setState({isResetPasswordModalVisible: true})
                                }
                                outline
                                color={this.props.isActive ? "warning" : "success"}
                                className={`btn`}
                                size="sm"
                            >
                                Reset Password
                            </Button>

                            <ActivationButton
                                isActive={this.state.user.isActive}
                                description="User"
                                item={this.state.user}
                                toggleFunction={this.changeUserStatus}
                                header={` user:${this.state.user.firstName} ${this.state.user.lastName}`}
                            />

                        </div>
                    </div>

                    <UserHeader
                        user={this.state.user}
                    />

                    <Tabs defaultActiveKey="apps" id="uncontrolled-tab-example">
                        <Tab eventKey="apps" title="Products">
                            <UserApps
                                user={this.state.user}
                                updateUser={this.updateUser}
                            />
                        </Tab>

                        <Tab eventKey="history" title="History">
                            <History id={this.props.match.params.id}
                                     userName={this.state.user.firstName + ' ' + this.state.user.lastName}/>
                        </Tab>
                    </Tabs>


                </div>

                {/* Resend verification */}
                <ConfirmDialog
                    toggleState={this.state.isResendVerificationModalVisible}
                    cancelAction={() =>
                        this.setState({isResendVerificationModalVisible: false})
                    }
                    message={`Would you like to resend a verification email to ${this.state.user.firstName} ${this.state.user.lastName}?`}
                    confirmAction={() => this.handleResendVerification()}
                    confirmActionName="Send"
                    caption="Resend Verification"
                    confirmClassName={"btn-success"}
                    isLoading={this.state.isDialogLoading}
                />

                {/* Reset password */}
                <CreateDialog
                    isModalVisible={this.state.isResetPasswordModalVisible}
                    isDialogLoading={this.state.isDialogLoading}
                    handleDialogToggle={() => {
                        this.setState({isResetPasswordModalVisible: false})
                    }}
                    cancelAction={this.resetState}
                    action={this.resetPassword}
                    modalHeaderName="Change Password"
                    modalBodyFields={[
                        {
                            label: "Password",
                            id: "password",
                            inputType: "password",
                            onChange: this.validateNewPassword,
                            newField: this.state.newPassword,
                            defaultValue: this.state.newPassword
                        },
                        {
                            label: "Repeat Password",
                            id: "re_password",
                            inputType: "password",
                            onChange: this.validateReNewPassword,
                            validateFieldName: "",
                            isFieldInvalid: this.state.invalidFields.reNewPassword.invalid,
                            invalidFieldMessage: this.state.invalidFields.reNewPassword
                                .message,
                            newField: this.state.reNewPassword,
                            defaultValue: this.state.reNewPassword,
                            fieldClassName: "name-container"
                        }
                    ]}
                />

                {/* Edit user */}
                <CreateDialog
                    isModalVisible={this.state.isEditUserModalVisible}
                    isDialogLoading={this.state.isDialogLoading}
                    handleDialogToggle={this.handleEditDialogToggle}
                    action={this.editUser}
                    modalHeaderName="Edit User"
                    modalBodyFields={[
                        {
                            label: "First Name",
                            id: "auth0_firstName",
                            inputType: "text",
                            onChange: this.validName,
                            validateFieldName: "firstName",
                            isFieldInvalid: this.state.invalidFields.firstName.invalid,
                            invalidFieldMessage: this.state.invalidFields.firstName.message,
                            newField: this.state.user.firstName,
                            defaultValue: this.state.user.firstName
                        },
                        {
                            label: "Last Name",
                            id: "auth0_lastName",
                            inputType: "text",
                            onChange: this.validName,
                            validateFieldName: "lastName",
                            isFieldInvalid: this.state.invalidFields.lastName.invalid,
                            invalidFieldMessage: this.state.invalidFields.lastName.message,
                            newField: this.state.user.lastName,
                            defaultValue: this.state.user.lastName
                        },
                        {
                            label: "DTN Employee",
                            id: "auth0_employee",
                            inputType: "checkbox",
                            onChange: this.setIsEmployee,
                            newField: this.state.user.isDtnEmployee,
                            defaultValue: this.state.user.isDtnEmployee
                        }
                    ]}
                />
            </App>
        );
    }
}

export default UserProfile;



// WEBPACK FOOTER //
// ./src/user-profile/UserProfile.js